import React, { Fragment, PureComponent } from 'react'
import cx from 'classnames'
import { compose, links } from 'helpers'
import { connect } from 'redaction'

import injectGlobals from 'local_modules/injectGlobals'

import Header from './Header/Header'
import Layers from './Layers/Layers'
import WebViewLayers from './WebViewLayers/WebViewLayers'

import s from './CommonLayout.scss'


class CommonLayout extends PureComponent {

  UNSAFE_componentWillMount() {
    const { isCashierWebView, isLoggedIn, redirect } = this.props

    if (isCashierWebView && !isLoggedIn) {
      redirect(links.marketplace.login)
    }
  }

  render() {
    const { children, isOldBrowser, isLoggedIn, isWebView, isCashierWebView } = this.props

    const isWeb = isWebView || isCashierWebView

    return (
      <div>
        {
          isWebView && (
            <WebViewLayers />
          )
        }
        {
          (isCashierWebView && isLoggedIn) && (
            <WebViewLayers />
          )
        }
        {
          !isWeb && (
            <Fragment>
              <Header />
              <Layers />
            </Fragment>
          )
        }
        <div
          className={cx({
            [s.content]: !isWeb,
            [s.webViewContent]: isWeb,
          })}
        >
          {children}
        </div>
      </div>
    )
  }
}


export default compose(
  injectGlobals(({ globals, getCookieValue, redirect }) => ({
    redirect,
    isOldBrowser: globals.isOldBrowser,
    isWebView: Boolean(getCookieValue('isWebView')),
    isCashierWebView: Boolean(getCookieValue('isCashierWebView')),
  })),
  connect({
    isLoggedIn: 'me.isLoggedIn',
  }),
)(CommonLayout)
